module.exports = __webpack_public_path__ + "static/media/frames-23.e09e4fc1.jpg";